import React, {useState, useEffect} from 'react';
import { CalendarIcon, CurrencyDollarIcon, XMarkIcon } from '@heroicons/react/24/outline';
import config from '../config';
import Helper from "../helpers";

const baseUrl = config.apiBaseUrl;

const BookSession = ({handleClose, Values}) => {
    const [sessions, setSessions] = useState([]);
    const [selectedSession, setSelectedSession] = useState(Values.sessionId);
    const [sessionCost, setSessionCost] = useState(Values.sessionCost);

    const updateSelectedSession = (sessionId) => {
        let session = sessions.find(session => session.id === sessionId);
        setSelectedSession(sessionId);
        setSessionCost(session.tokenCost);
    }


    useEffect( () => {
        // Fetch available sessions
        async function fetchSessions() {
            const token = await Helper.getCookie('wh-jwt');
            let venue = await Helper.getUserVenueId();
            fetch(`${baseUrl}/api/Sessions/available/${venue}?from=${encodeURIComponent(new Date().toISOString())}&to=${encodeURIComponent(new Date(new Date().setDate(new Date().getDate() + 31)).toISOString())}`, {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    },
                    credentials: 'include'
                }
            )
                .then(response => response.json())
                .then(data => setSessions(data))
                .catch(error => console.error('Error fetching sessions:', error));
        }
        fetchSessions();
    }, []);

    const handleBookSession = async () => {
        const token = await Helper.getCookie('wh-jwt');
        fetch(`${baseUrl}/api/Sessions/book/${selectedSession}`, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            credentials: 'include'
        })
            .then(response => {
                if (response.ok) {
                    return response.json();
                } else {
                    alert('Failed to book session');
                }
            })
            .then(data => {
                if (data) {
                    alert('Session booked successfully');
                    handleClose();
                    window.location.reload();
                } else {
                    alert('Failed to book session');
                }
            })
            .catch(error => {
                console.error('Error booking session:', error);
                alert('Failed to book session');
            });
    };

    return (
        <div className="card-luxury p-6 sm:p-8 max-w-2xl mx-auto animate-slide-up">
            {/* Header */}
            <div className="flex justify-between items-start mb-6">
                <div>
                    <h2 className="text-2xl sm:text-3xl font-display font-bold text-emerald-700 mb-2">
                        Book a Session
                    </h2>
                    <div className="flex items-center gap-2 text-sm sm:text-base">
                        <CurrencyDollarIcon className="h-5 w-5 text-emerald-400" />
                        <p className="text-accent-platinum font-body">
                            This session will cost <span className="font-display font-bold text-emerald-300">{sessionCost}</span> token{sessionCost !== 1 ? 's' : ''}
                        </p>
                    </div>
                </div>
                <button
                    onClick={handleClose}
                    className="text-emerald-600/60 hover:text-emerald-300 transition-colors duration-300"
                >
                    <XMarkIcon className="h-6 w-6" />
                </button>
            </div>

            {/* Session Selector */}
            <div className="mb-6">
                <label className="flex items-center gap-2 text-sm font-display font-semibold text-emerald-300/80 mb-3 uppercase tracking-wide">
                    <CalendarIcon className="h-4 w-4" />
                    Select Session
                </label>
                <select
                    value={selectedSession}
                    onChange={(e) => updateSelectedSession(e.target.value)}
                    className="input-field w-full"
                >
                    {sessions.map((session) => (
                        <option key={session.id} value={session.id}>
                            {`${session.name} - ${new Date(session.startDate).toLocaleString()}`}
                        </option>
                    ))}
                </select>
            </div>

            {/* Action Buttons */}
            <div className="flex flex-col sm:flex-row gap-3 mt-8">
                <button
                    onClick={handleClose}
                    className="btn-outline flex-1 order-2 sm:order-1"
                >
                    Cancel
                </button>
                <button
                    onClick={handleBookSession}
                    className="btn-primary flex-1 order-1 sm:order-2"
                >
                    Book Session
                </button>
            </div>
        </div>
    );
};

export default BookSession;
